import { Controller } from "@hotwired/stimulus"

/** When applying a process to a client: show schedule overrides and prefill from selected <option> data-* . */
export default class extends Controller {
  static targets = ["panel", "time", "wday", "mday", "month"]

  connect() {
    this._onChange = () => this.onProcessChange()
    this.selectEl = this.element.querySelector("select[name='testing_process_id']")
    if (this.selectEl) {
      this.selectEl.addEventListener("change", this._onChange)
    }
    this.onProcessChange()
  }

  disconnect() {
    if (this.selectEl) {
      this.selectEl.removeEventListener("change", this._onChange)
    }
  }

  onProcessChange() {
    const opt = this.selectEl?.selectedOptions[0]
    if (!opt || !this.hasPanelTarget) return

    const interval = opt.dataset.scheduleInterval || ""
    if (interval === "") {
      this.panelTarget.classList.add("is-hidden")
      return
    }

    this.panelTarget.classList.remove("is-hidden")
    if (this.hasTimeTarget) this.timeTarget.value = opt.dataset.scheduleTime || ""
    if (this.hasWdayTarget) this.wdayTarget.value = opt.dataset.scheduleWday ?? ""
    if (this.hasMdayTarget) this.mdayTarget.value = opt.dataset.scheduleMday ?? ""
    if (this.hasMonthTarget) this.monthTarget.value = opt.dataset.scheduleMonth ?? ""

    this._toggleRows(interval)
  }

  _toggleRows(interval) {
    const weekly = this.element.querySelector("[data-apply-schedule-weekly]")
    const monthly = this.element.querySelector("[data-apply-schedule-monthly]")
    const yearly = this.element.querySelector("[data-apply-schedule-yearly]")
    if (weekly) weekly.classList.toggle("is-hidden", interval !== "weekly")
    if (monthly) monthly.classList.toggle("is-hidden", !["monthly", "quarterly", "yearly"].includes(interval))
    if (yearly) yearly.classList.toggle("is-hidden", interval !== "yearly")
  }
}
